import React from 'react';
import { useMapCanvasInteraction } from '../contexts/MapCanvasContext';
import { useMapEditorTool } from '../contexts/MapEditorContext';

export interface AltToolsListenerReturn {
  isAltPaneActive: boolean;
  setIsAltPaneActive: (value: boolean) => void;
}

export const useAltToolsListener = (): AltToolsListenerReturn => {
  const { activeTool: tool } = useMapEditorTool();
  const { setSelectionBox, setSelectionStart, setIsDragging } = useMapCanvasInteraction();
  const [isAltPaneActive, setIsAltPaneActive] = React.useState(false);

  React.useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (tool !== 'pan' && event.code === 'Space') {
        setIsAltPaneActive(true);
        setSelectionStart(null);
        setSelectionBox(null);
        setIsDragging(true);
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      if (isAltPaneActive) {
        setIsAltPaneActive(false);
        setIsDragging(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [tool, isAltPaneActive]);

  return {
    isAltPaneActive,
    setIsAltPaneActive
  };
};
